<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
  <div>
    script
    <div class="row ml-1">
      <div class="card bg-primary p-3 text-white">
        <table>
          <tr>
            <td>
              <h4>Kode RPL</h4>
            </td>
            <td>
              <h4>: {{ detailSertifikasi.kodeRpl }}</h4>
            </td>
          </tr>
          <tr>
            <td>
              <h4>Nama RPL</h4>
            </td>
            <td>
              <h4>: {{ detailSertifikasi.namaRpl }}</h4>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <CCard class="mt-3">
      <CCardHeader class="bg-primary text-white d-flex align-items-center">
        Data Peserta
        <!-- <CButton color="info" style="float:right;margin-right:10px" class="btn-md ml-auto">Print</CButton> -->
        <CButton
          color="danger"
          style="float:right;margin-right:10px"
          class="btn-md ml-auto"
        >Export PDF</CButton>
        <CDropdown
          toggler-text="Ekspor Excel"
          color="warning"
          class="mr-2 d-inline-block text-white float-right"
        >
          <CDropdownItem>Export All</CDropdownItem>
          <CDropdownItem>Export Page</CDropdownItem>
        </CDropdown>
      </CCardHeader>
      <!-- Data Jadwal TC -->
      <CCardBody>
        <CRow>
          <div class="col-sm-12 col-xl-2">
            <div class="form-group">
              <CSelect
                label="Data Perhalaman"
                class="float-left"
                @change="changePageSize"
                :options="[10, 25, 100, 'Semua Data']"
              />
            </div>
          </div>
          <div class="col-sm-12 col-xl-3 ml-auto">
            <div class="form-group">
              <label for>Pencarian</label>
              <input type="text" name id class="form-control" placeholder="Cari Data ..." />
            </div>
          </div>
        </CRow>
        <CRow>
          <CCol lg="12" class="table-responsive">
            <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
              <template #no="{index}">
                <td class="py-2">{{ indexed == 0 ? index +1: index+indexed + 1 }}</td>
              </template>
              <template #tombol_dokumen_terverifikasi="{item}">
                <td class="py-2">
                  <button
                    class="btn btn-sm btn-success"
                    v-if="item.tombol_dokumen_terverifikasi == 1"
                  >Terverifikasi</button>
                  <button class="btn btn-sm btn-danger" v-else>Belum Terverifikasi</button>
                </td>
              </template>
              <template #no_anggota={item}>
                <td class="py-2"> {{ item.no_anggota ? item.no_anggota : '-' }} </td>
              </template>
              <template #no_telephone={item}>
                <td class="py-2"> {{ item.no_telephone ? item.no_telephone : '-' }} </td>
              </template>
              <template #absen_pagi={item}>
                <td class="py-2"> {{ item.absen_pagi ? item.absen_pagi : '-' }} </td>
              </template>
              <template #absen_siang={item}>
                <td class="py-2"> {{ item.absen_siang ? item.absen_siang : '-' }} </td>
              </template>
              <template #aksi="{item}">
                <td class="py-2 d-flex align-items-center">
                  <CButton
                    color="warning"
                    class="btn-sm text-white"
                    square
                    @click="modalEmail = true"
                  >
                    <font-awesome-icon icon="envelope" @click="modalEmail = true" />
                  </CButton>&nbsp;&nbsp;
                  <CButton color="success" class="btn-sm mx-1" square @click="getDokumenPendukungPeserta(item.id_sertifikasi_rpl_peserta)">
                    <font-awesome-icon icon="file" />
                  </CButton>&nbsp;&nbsp;
                  <CButton color="info" class="btn-sm" square @click="absenClick(item.id_sertifikasi_rpl_peserta,item.nama_lengkap)">
                    <font-awesome-icon icon="edit" />
                  </CButton>
                </td>
              </template>
            </CDataTable>
            <CPagination
              style="float:right"
              :active-page.sync="currentPage"
              :pages="pagination.totalPages"
              responsive
              @click="pageChange"
            />
          </CCol>
        </CRow>
        <!-- Modal Edit -->
        <CModal
          title="Modal title"
          :show.sync="modalEdit"
          :no-close-on-backdrop="true"
          :centered="true"
        >
          <CForm>
            <CRow>
              <div class="modal-body">
                <form @submit.prevent="postAbsen">
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label for="nama" class="font-weight-bold">Nama</label>
                      <input type="text" class="form-control" v-model="formAbsen.namaLengkap" id="nama" disabled />
                    </div>
                    <div class="form-group col-md-6">
                      <label for="absen" class="font-weight-bold">Absen Pagi</label>
                      <input
                        type="time"
                        class="form-control"
                        id="absen"
                        :disabled="statusReadOnly == 0"
                        v-model="formAbsen.absenPagi"
                        placeholder="Masukkan Absen Pagi"
                      />
                    </div>
                    <div class="form-group col-md-6">
                      <label for="absen" class="font-weight-bold">Absen Siang</label>
                      <input
                        type="time"
                        class="form-control"
                        id="absen"
                        :disabled="statusReadOnly == 0"
                        v-model="formAbsen.absenSiang"
                        placeholder="Masukkan Absen Siang"
                      />
                    </div>
                  </div>
                  <div class="form-row" v-for="val in formAbsen.nilaiMataUji" v-bind:key="val">
                    <div class="form-group col-12 mt-2">
                      <h5 class="font-weight-bold">Nilai Mata Uji</h5>
                    </div>
                    <div class="form-group col-md-6">
                      <label for="absen" class="font-weight-bold">Mata Uji {{ val.namaMataUji }}</label>
                      <label for="" class="font-weight-bold">Batas Nilai : {{ val.nilaiMinimum }}</label>
                    </div>
                    <div class="form-group col-md-12">
                      <!-- <label for="absen" class="font-weight-bold">Batas Nilai</label> -->
                      <input type="number" min="0" :placeholder="val.idMataUjiPeserta == '' ? 'Belum Mengikuti Mata Uji' : '' " v-model="val.nilai" class="form-control" id="absen" :disabled="val.idMataUjiPeserta == ''" />
                    </div>
                  </div>
                
                </form>
              </div>
            </CRow>
          </CForm>
          <template #header>
            <h6 class="modal-title h4 font-weight-bold">Edit</h6>
            <span class="text-warning" v-if="statusReadOnly == 0">*Belum Mengikuti Mata Uji</span>
          </template>
          <template #footer>
            <CButton @click="modalEdit = false" color="danger">Tutup</CButton>
            <CButton type="submit" @click="postAbsen" color="success">Simpan</CButton>
          </template>
        </CModal>
        <!-- End Modal -->

        <!-- Modal Verif -->
        <CModal
          title="Modal title"
          :show.sync="modalVerif"
          :no-close-on-backdrop="true"
          :centered="true"
          size="lg"
        >
            <CRow>
              <div class="modal-body">
                <table class="table">
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Nama File</th>
                      <th>File</th>
                      <th class="text-center">Status</th>
                      <th class="text-center">Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(val,k) in dataDokumen" :key="k">
                      <td scope="row">{{ k+1 }}</td>
                      <td>{{ val.namaDokumen }}</td>
                      <td>
                        <a :href="baseUrlFo+'/dokumen_persyaratan_workshop/'+val.file" target="_blank" v-if="val.file != ''"> Lihat File</a>
                        <span class="text-primary" v-else>Lihat File</span>
                      </td>
                      <td class="text-center">
                        <button class="btn btn-sm btn-secondary text-center"  v-if="val.statusUpload == '0'">Belum Upload</button>
                        <button class="btn btn-sm btn-success text-center"   v-else-if="val.statusUpload == '1'">Terverifikasi</button>
                        <button class="btn btn-sm btn-primary text-center"   v-else-if="val.statusUpload == '2'">Sudah Upload</button>
                        <button class="btn btn-sm btn-info text-center"  v-else-if="val.statusUpload == '3'">File Tidak Terbaca</button>
                        <button class="btn btn-sm btn-danger text-center"   v-else-if="val.statusUpload == '4'">File Tidak Sesuai</button>
                      </td>
                      <td class="text-center">
                        <button
                          class="btn btn-sm btn-info"
                          :disabled="val.idDokumenPendukungRpl == ''"
                          @click="aksiVerif(val)"
                          v-c-tooltip="'Verifikasi'"
                        >
                        <small><i class="fa fa-check"  ></i></small>
                        </button>
                      </td>
                    </tr>
                    
                  </tbody>
                </table>                
              </div>
            </CRow>
          <template #header>
            <h6 class="modal-title h5 font-weight-bold">Verifikasi Dokumen Persyaratan Peserta RPL</h6>
          </template>
        </CModal>
        <!-- End Modal -->

        <!-- Modal Aksi Verif -->
        <CModal
          title="Modal title"
          :show.sync="modalAksiVerif"
          :no-close-on-backdrop="true"
          :centered="true"
        >
          <CForm>
            <CRow>
              <div class="modal-body">
                <CRow>
                  <CCol sm="12 mb-4">
                    <label for class="font-weight-bold">Status</label>
                    <input type="hidden" name="" v-model="formVerifDokumen.idDokumenPendukungRpl">
                    <br />
                    <select class="form-control mb-2" v-model="formVerifDokumen.statusUpload">
                      <option value="0">Belum Upload</option>
                      <option value="1">Terverifikasi</option>
                      <option value="2">Sudah Upload</option>
                      <option value="3">File Tidak Terbaca</option>
                      <option value="4">File Tidak Sesuai</option>
                    </select>
                  </CCol>
                </CRow>
              </div>
            </CRow>
          </CForm>
          <template #header>
            <h6 class="modal-title h5 font-weight-bold">Verifikasi</h6>
          </template>
          <template #footer>
            <CButton @click="modalAksiVerif = false" color="danger">Tutup</CButton>
            <CButton type="submit" @click="postVerifikasi" color="success">Simpan</CButton>
          </template>
        </CModal>
        <!-- End Modal -->

        <!-- Modal Email -->
        <CModal
          title="Modal title"
          :show.sync="modalEmail"
          :no-close-on-backdrop="true"
          :centered="true"
        >
          <CForm>
            <CRow>
              <CCol sm="12">
                <CInput class="font-weight-bold" label="Subjek" placeholder="Masukkan Subjek" />
              </CCol>
              <CCol sm="12">
                <CTextarea
                  class="font-weight-bold"
                  label="Pesan"
                  rows="3"
                  placeholder="Masukkan isi pesan"
                />
              </CCol>

              <CCol sm="12 mb-5">
                <label for="uid-zwqayuopq3" class="font-weight-bold">File (Opsional)</label>
                <br />
                <div class="custom-file text-truncate">
                  <div class="custom-file text-truncate">
                    <input
                      type="file"
                      class="custom-file-input"
                      id="customFileLangHTML"
                      placeholder="Plih File"
                    />
                    <label
                      class="custom-file-label"
                      for="customFileLangHTML"
                      data-browse="Unggah"
                    >{{ fileName }}</label>
                  </div>
                </div>
              </CCol>
            </CRow>
          </CForm>
          <template #header>
            <h6 class="modal-title h4 font-weight-bold">Kirim Email</h6>
          </template>
          <template #footer class="mt-5">
            <CButton @click="modalEmail = false" color="danger">Tutup</CButton>
            <CButton type="submit" color="success">Kirim</CButton>
          </template>
        </CModal>
        <!-- End Modal -->
      </CCardBody>
      <!-- End Data Data Peserta -->
    </CCard>
  </div>
</template>
<script>
import RplWorkshopService from "../../../../services/sertifikasi/master-rpl-workshop.service";

const fields = [
  {
    key: "no",
    sorter: false,
    filter: false
  },
  {
    key: "no_anggota",
    label: "No. Anggota",
    sorter: true,
    filter: false
  },
  {
    key: "nama_lengkap",
    label: "Nama",
    sorter: true,
    filter: false
  },
  {
    key: "nama_level",
    label: "Level",
    sorter: true,
    filter: false
  },
  {
    key: "no_telephone",
    label: "No. Telepon",
    sorter: true,
    filter: false
  },
  {
    key: "absen_pagi",
    label: "Absen Pagi",
    sorter: true,
    filter: false
  },
  {
    key: "absen_siang",
    label: "Absen Siang",
    sorter: true,
    filter: false
  },
  {
    key: "tombol_dokumen_terverifikasi",
    label: "Persyaratan Dokumen",
    sorter: true,
    filter: false
  },

  {
    key: "aksi",
    _style: "width:10%; text-align: center",
    sorter: false,
    filter: false
  }
];

export default {
  name: "Master RPL",
  data() {
    return {
      baseUrlFo : process.env.VUE_APP_BASE_URL_BACKEND,
      pageSize: "",
      search: "",
      items: [],
      statusReadOnly : 0,
      formData: {
        judul: "",
        file: ""
      },
      pagination: {
        totalPages: 0
      },
      formData: {
        deskripsi: "",
        file: ""
      },
      formAbsen : {
        idSertifikasiRplPeserta : '',
        absenPagi : '',
        absenSiang : '',
        nama_lengkap : '',
        nilaiMataUji : []
      },
      dataDokumen : [],
      formVerifDokumen : {
        idDokumenPendukungRpl : '',
        statusUpload : '',
        id_sertifikasi_rpl_peserta : ''
      },
      currentPage: 0,
      details: [],
      fileName: "Choose File...",
      fields,
      details: [],
      no: 1,
      status: false,
      modalEdit: false,
      modalEmail: false,
      modalVerif: false,
      modalAksiVerif: false,
      horizontal: { label: "col-3", input: "col-9" },
      indexed: 0,
      collapseDuration: 0,
      content: [],
      detailSertifikasi : {
        kodeRpl : '',
        namaRpl : ''
      }
    };
  },
  mounted() {
    this.getData("0", this.pageSize, "default");
    this.getDetailSertifikasi();
  },
  watch: {
    currentPage: function(val){
      //alert val -1 
      var page = val - 1;
      this.indexed = page * 10;
      this.getData(val - 1, this.pageSize, this.search);
    }
  },
  methods: {
    aksiVerif(val) {
      this.modalAksiVerif = true;
      this.formVerifDokumen.idDokumenPendukungRpl = val.idDokumenPendukungRpl;
      this.formVerifDokumen.statusUpload = val.statusUpload;
    },
    postVerifikasi(){
      var vm = this;
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      RplWorkshopService.verifikasiDokumenPeserta(this.formVerifDokumen)
      .then(response => {
        
        // setTimeout(() => loader.hide(), 1000);
        vm.getData("0", vm.pageSize, "default");
        loader.hide()
        this.getDokumenPendukungPeserta(this.formVerifDokumen.id_sertifikasi_rpl_peserta);
        this.alertSuccess();
        vm.modalAksiVerif = false;

        // loader.hide();
      })
      .catch(error => {
        // comment console console.log(error);
        loader.hide
        this.alertError()

      });
    },
    getDokumenPendukungPeserta(id_sertifikasi_rpl_peserta) {
      this.modalVerif = true;
      this.formVerifDokumen.id_sertifikasi_rpl_peserta = id_sertifikasi_rpl_peserta;
      RplWorkshopService.getDokumenRplPeserta(id_sertifikasi_rpl_peserta)
      .then(response => {
        this.dataDokumen = response.data.data   
        // setTimeout(() => loader.hide(), 1000);
        // loader.hide()
      
        // loader.hide();
      })
      .catch(error => {
        // comment console console.log(error);
        // loader.hide
        // this.alertError()

      });
    },
    postAbsen() {
      var vm = this;
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      RplWorkshopService.absenPeserta(this.formAbsen)
      .then(response => {
        vm.getData("0", vm.pageSize, "default");
        // setTimeout(() => loader.hide(), 1000);
        loader.hide()
        this.alertSuccess();
        vm.modalEdit = false;

        // loader.hide();
      })
      .catch(error => {
        // comment console console.log(error);
        loader.hide
        this.alertError()

      });

    },
    getDetailSertifikasi() {
      
      RplWorkshopService.getDetailRplWorkshop(this.$route.params.id_sertifikasi_rpl)
      .then(response => {
        this.detailSertifikasi.kodeRpl = response.data.singleData.kodeRpl;
        this.detailSertifikasi.namaRpl = response.data.singleData.namaRpl; 
        // loader.hide();
      })
      .catch(error => {
        // comment console console.log(error);
      });
    },
    absenClick(id_sertifikasi_rpl_peserta,nama_lengkap) {
      this.modalEdit = true
      this.formAbsen.namaLengkap = nama_lengkap;
      this.formAbsen.idSertifikasiRplPeserta = id_sertifikasi_rpl_peserta
      this.getDataMataUjiPeserta(id_sertifikasi_rpl_peserta)
    },
    changePageSize(e) {
      // comment console console.log(e.target.value);
      var pageSize = "";

      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search);
    },
    pageChange() {
      this.getData(this.currentPage, this.pageSize, this.search);
    },
    cariData(){
      this.getData("0", this.pageSize, this.search);
    },
    alertError() {
      this.$swal.fire({
        title: "Peringatan!",
        text: "Data Gagal Disimpan",
        icon: "errorr",
        showCancelButton: true
      });
    },
    alertSuccess() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Disimpan"
      });
    },
    getDataMataUjiPeserta(id_sertifikasi_rpl_peserta) {
      var vm = this;
      RplWorkshopService.getDetailMataUjiPeserta(id_sertifikasi_rpl_peserta)
      .then(response => {
    
        vm.formAbsen.absenPagi = response.data.singleData.data_absen.absenPagi;
        vm.formAbsen.absenSiang = response.data.singleData.data_absen.absenSiang;
        vm.formAbsen.nilaiMataUji = response.data.singleData.mata_uji;
        var statusReadOnly = 0
        for (let index = 0; index < response.data.singleData.mata_uji.length; index++) {
          if(response.data.singleData.mata_uji[index].idMataUjiPeserta != '') {
            statusReadOnly = 1
          }
          
        }        

        vm.statusReadOnly = statusReadOnly;
        // comment console console.log(vm.formAbsen.nilaliMataUji)
        // loader.hide();
      })
      .catch(error => {
        // comment console console.log(error);
      });
    },
    getData(currentPage, pageSize, filter) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      var vm = this;
      RplWorkshopService.getDataPeserta(currentPage, pageSize, filter,this.$route.params.id_sertifikasi_rpl)
        .then(response => {
          loader.hide();
          vm.items = response.data.data.content;
          vm.pagination.totalPages = response.data.data.totalPages;
          vm.currentPage = response.data.data.pageable.pageNumber + 1;

          setTimeout(() => loader.hide(), 1000);
          // loader.hide();
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },
  }
};
</script>